(ns minorodata.connections.sources.s3-file-ingest
  (:require [minorodata.app.utils :as app.utils]))



(def source
  {:id           "s3-file-ingest"
   :enabled      true
   :name         "Amazon S3"
   :description  "Object storage built to store and retrieve any amount of data from anywhere"
   :image-source "s3.png"
   :tags         ["data-import"]

   :preview-formatter
   (fn []
     (str "Authenticated with an Access Key"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [region access-key secret-key name description]} data]
        {:source-type "s3-file-ingest"
         :name        name
         :description description

         :source
         {:credentials {:region     region
                        :access-key access-key
                        :secret-key secret-key}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:region :access-key :secret-key]))))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id       :s3-file-ingest-form

    :blocks   [{:block-type :input
                :label      "Source name"
                :required   true
                :name       :name
                :value      ""}
               {:block-type :input
                :label      "Description"
                :name       :description
                :value      ""}
               {:block-type :input
                :label      "Region"
                :name       :region
                :required   true
                :value      ""}
               {:block-type :input
                :label      "Access Key"
                :name       :access-key
                :type       :password
                :required   true
                :value      ""}
               {:block-type :input
                :label      "Secret Key"
                :name       :secret-key
                :type       :password
                :required   true
                :value      ""}

               {:block-type :submit
                :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status filter-files? regex-pattern file-name separator
                 bucket path path-type load-time-range type sheet-name header destination-table action]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:bucket            bucket
                    :path              path
                    :path-type         path-type
                    :file-name         file-name
                    :separator         separator
                    :load-time-range   load-time-range
                    :type              type
                    :sheet-name        (when (or (= "xls" type)
                                                 (= "xlsx" type))
                                         sheet-name)

                    :header            header
                    :filter-files?     filter-files?
                    :regex-pattern     regex-pattern
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:bucket :path :path-type :file-name :load-time-range :type :regex-pattern
                               :sheet-name :header :filter-files? :destination-table :action :separator])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id       :s3-file-ingest-extract-form

    :blocks   [{:block-type :input
                :label      "Extract name"
                :required   true
                :name       :name
                :value      ""}
               {:block-type :input
                :label      "Description"
                :name       :description
                :value      ""}

               {:block-type :select
                :label      "Status"
                :name       :status
                :options    [{:name "Active" :value "active"}
                             {:name "Paused" :value "paused"}]
                :required   true
                :value      "active"}

               {:block-type :subtitle
                :content    "Extract Configuration"}

               {:block-type :input
                :label      "S3 bucket name"
                :required   true
                :name       :bucket
                :value      ""}

               {:block-type :select
                :label      "Load a single filename or files under a folder"
                :options    [{:name "Load a single file" :value "filename"}
                             {:name "Load all files inside a folder" :value "folder"}
                             {:name "Load a single file inside a ZIP" :value "zip-filename"}
                             {:name "Load all files inside a ZIP" :value "zip-folder"}
                             {:name "Load compressed files (ZIP/GZ) from folder" :value "compressed-folder"}]
                :required   true
                :name       :path-type
                :value      "filename"}

               {:block-type :input
                :label      "File or folder name"
                :required   true
                :name       :path
                :value      ""
                :conditions [[:eq [:path-type :value] "filename"]
                             [:eq [:path-type :value] "folder"]
                             [:eq [:path-type :value] "compressed-folder"]]}

               {:block-type :input
                :label      "Zipped file name"
                :required   true
                :name       :path
                :value      ""
                :conditions [[:eq [:path-type :value] "zip-filename"]
                             [:eq [:path-type :value] "zip-folder"]]}

               {:block-type :input
                :label      "File name"
                :required   true
                :name       :file-name
                :value      ""
                :conditions [[:eq [:path-type :value] "zip-filename"]]}

               {:block-type :select
                :label      "File type"
                :name       :type
                :options    [{:name "XLS" :value "xls"}
                             {:name "XLSX" :value "xlsx"}
                             {:name "CSV" :value "csv"}
                             {:name "TXT" :value "txt"}
                             {:name "JSON" :value "json"}
                             {:name "XML" :value "xml"}
                             {:name "PARQUET" :value "parquet"}
                             {:name "DYNAMODB EXPORT" :value "dynamodb-export"}
                             {:name "AVRO" :value "avro"}]
                :required   true
                :value      "csv"
                :conditions [[:eq [:path-type :value] "filename"]
                             [:eq [:path-type :value] "folder"]]}

               {:block-type :select
                :label      "File type"
                :name       :type
                :options    [{:name "CSV" :value "csv"}
                             {:name "TXT" :value "txt"}]
                :required   true
                :value      "csv"
                :conditions [[:eq [:path-type :value] "zip-filename"]
                             [:eq [:path-type :value] "zip-folder"]
                             [:eq [:path-type :value] "compressed-folder"]]}

               {:block-type :select
                :label      "Values delimiter"
                :name       :separator
                :options    [{:name "Tab" :value "tab"}
                             {:name "Pipe" :value "pipe"}
                             {:name "Comma" :value "coma"}]
                :value      "coma"
                :conditions [[:eq [:type :value] "txt"]]}

               {:block-type :input
                :label      "Sheet name"
                :required   false
                :name       :sheet-name
                :value      ""
                :conditions [[:eq [:type :value] "xls"]
                             [:eq [:type :value] "xlsx"]]}

               {:block-type :checkbox
                :label      "Header"
                :name       :header
                :type       :checkbox
                :value      false}

               {:block-type :checkbox
                :label      "Filter Files"
                :name       :filter-files?
                :type       :checkbox
                :value      false
                :conditions [[:eq [:path-type :value] "folder"]
                             [:eq [:path-type :value] "zip-folder"]
                             [:eq [:path-type :value] "compressed-folder"]]}

               {:block-type :input
                :label      "Regex Pattern"
                :required   false
                :name       :regex-pattern
                :value      ""
                :conditions [[:and [[:filter-files? :value] [:path-type :value]] [true "folder"]]
                             [:and [[:filter-files? :value] [:path-type :value]] [true "zip-folder"]]
                             [:and [[:filter-files? :value] [:path-type :value]] [true "compressed-folder"]]]}

               {:block-type :select
                :label      "Load method"
                :name       :action
                :options    [{:name "Drop, Create, Load" :value "replace"}
                             {:name "Truncate, Load" :value "reload"}
                             {:name "Append" :value "append"}]
                :required   true
                :value      "replace"}

               {:content    "Drop table, Create table, load entire dataset"
                :conditions [[:eq [:action :value] "replace"]]}

               {:content    "Truncate table, Load entire dataset"
                :conditions [[:eq [:action :value] "reload"]]}

               {:content    "Append only will add new files from the folder, as defined above, to the existing table and it's data"
                :conditions [[:eq [:action :value] "append"]]}

               {:block-type :input
                :label      "Load only files newer than X number of days ago"
                :required   false
                :name       :load-time-range
                :value      ""
                :conditions [[:eq [:path-type :value] "folder"]
                             [:eq [:path-type :value] "zip-folder"]
                             [:eq [:path-type :value] "compressed-folder"]]}

               {:block-type :subtitle
                :content    "Destination table"}

               {:block-type :warehouse-destination
                :name       :destination-table}

               {:block-type :submit
                :content    "SAVE"}]}})
